import React, { Fragment, memo } from "react";
import { Center, Flex, Text, HStack } from "@chakra-ui/react";
import { getAlohaSupportData } from "@/constants/alohainfo-contants";
import SupportItemComponent from "./item";
export default memo(function ProjectSupportedComponent() {
   const list = getAlohaSupportData();
   return (
      <Flex flexDir={"column"} bg="#EFF7FA" alignItems="center">
         <Center mt={"120px"} w={"1280px"} mx={"auto"}>
            <Text fontSize={34}>Some of NFT Projects Supported by Our Bots</Text>
         </Center>
         <HStack spacing={"20px"} mt={"70px"} w={"1280px"} mx={"auto"} mb={"120px"}>
            {list.map((item,index) => {
               return (
                  <Fragment key={index}>
                     <SupportItemComponent item={item} />
                  </Fragment>
               );
            })}
         </HStack>
      </Flex>
   );
});
